export default __webpack_public_path__ + "fae95a8aafc64c9a8c7831bbff5756bc.svg";